import './ProfileBlock.less';
import React, {useRef, useState} from 'react';
import __ from "../../../i18n";
import Icon from "../../../../bootstrap/components/icon/Icon";
import Dropdown from "../../../../bootstrap/components/dropdown/Dropdown";
import routes from "../../../routing/routes";
import AuthContext from "../../../contexts/auth/AuthContext";
import {Link} from 'react-router-dom';
import UserAvatar from "../../../widgets/user-avatar/UserAvatar";


export default function ProfileBlock({}) {

    const [dropdownShown, setDropdownShown] = useState(false);

    const buttonRef = useRef(null);

    return <div className="profile-block">
        <AuthContext.Consumer>
            {
                ({user, avatarImage, canAccess, logout}) => <>
                    <div
                        className={'inline' + (dropdownShown ? ' active' : '')}
                        onClick={() => setDropdownShown(!dropdownShown)}
                        ref={buttonRef}
                    >
                        <div className="info">
                            <div className="profile-name">{user.full_name}</div>
                            <div className="profile-email">{user.email}</div>
                        </div>
                        <div className="avatar">
                            <UserAvatar image={avatarImage}/>
                        </div>
                    </div>
                    {
                        dropdownShown &&
                        buttonRef.current !== null &&
                        <Dropdown
                            name="top-nav-profile"
                            opener={buttonRef.current}
                            close={() => setDropdownShown(false)}
                            horizontalAlignment="right"
                        >
                            {
                                (contentViewableMaxHeight) => <>
                                    <div className="header">
                                        <span className="title">{__('Hello, ::user', {user: user.full_name})}</span>
                                    </div>
                                    <div className="body">
                                        <div
                                            className="links"
                                            onClick={ev => {
                                                if (ev.target.tagName === 'A') {
                                                    setDropdownShown(false);
                                                }
                                            }}
                                        >
                                            {
                                                canAccess(routes.library.path) &&
                                                <Link to={routes.library.getUrl()}>{__('My courses')}</Link>
                                            }
                                            {
                                                canAccess(routes.dashboard.path) &&
                                                <Link to={routes.dashboard.getUrl()}>{__('Dashboard')}</Link>
                                            }
                                            <Link to={routes.user_profile.getUrl(user.id)}>{__('Public profile')}</Link>
                                            <Link to={routes.account.getUrl()}>{__('Account settings')}</Link>
                                        </div>
                                        <div className="divider"/>
                                        <div className="actions">
                                            <a onClick={() => logout()}>
                                                <span className="text">{__('Sign out')}</span>
                                                <Icon name="sign-out"/>
                                            </a>
                                        </div>
                                    </div>
                                </>
                            }
                        </Dropdown>
                    }
                </>
            }
        </AuthContext.Consumer>
    </div>;
}
